module.exports = __webpack_public_path__ + "img/DLT.8d67bbb2.svg";